import { render, staticRenderFns } from "./UserBundles.vue?vue&type=template&id=f7b7b980&"
import script from "./UserBundles.vue?vue&type=script&lang=js&"
export * from "./UserBundles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports